export const styles = theme => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: '999',
    padding: theme.spacing(1, 0),
    margin: theme.spacing(5, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 0),
    },
  },

  greyBackground: {
    backgroundColor: '#fafafa',
    transition: 'background-color .5s',
  },

  // iconButton: {
  //   margin: theme.spacing(0, 3),
  // },

  searchButton: {
    backgroundColor: '#fff',
    color: theme.palette.primary.dark,
    '&:hover': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
  },

  chip: {
    backgroundColor: theme.palette.primary.light,
    maxWidth: '100%',
    height: 'auto',
    padding: theme.spacing(1),
  },

  chipLabel: {
    overflow: 'auto',
    whiteSpace: 'normal',
    paddingLeft: 12,
    paddingRight: 12,
    textOverflow: 'ellipsis',
    textAlign: 'center',
  },

  searchParamsSection: {
    marginTop: theme.spacing(2),
  },

  telespectadorSection: {
    fontWeight: 400,
    display: 'inline-block',
  },

  telespectadorName: {
    fontWeight: 500,
  },

  dateSection: {
    fontWeight: 300,
    display: 'inline',
  },

  dateSectionName: {
    fontWeight: 400,
  },
})
